import { SYSTEM_DEFAULTS, ERROR_MESSAGES, HTTP } from "./constants";
import HelperFunction from "./helper";

export default class APIFunction {
    static async getUserSavingsPlan (page) {
        try {
            const storedUser = JSON.parse(localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE));
    
            if (!storedUser) {
                throw new Error(ERROR_MESSAGES.MISSING_USER_ID);
            }
            
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/savings-plan?page=${page}&limit=${SYSTEM_DEFAULTS.PAGE_SIZE}`);
            if (!res.ok) {
              throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
    
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getProfileSummery() {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/user-packages-summery`);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getUserSummery () {
        try {            
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/user`);
            if (!res.ok) {
              throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
    
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getUserTransactions (page) {
        try {            
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/transactions?page=${page}&limit=${SYSTEM_DEFAULTS.PAGE_SIZE}`);
            if (!res.ok) {
              throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
    
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getUserTransactionsSummery (period) {
        try {            
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/transaction-period/${period}`);
            if (!res.ok) {
              throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
    
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getUnreadNotifications () {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/notifications/unread`);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getNotifications (page) {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/notifications?page=${page}&limit=${SYSTEM_DEFAULTS.PAGE_SIZE}`);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async pollMPesaPaymanetStatus (checkoutRequestId) {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/mpesa/payments/status/${checkoutRequestId}`);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async mpesaSTKPush(form) {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/mpesa/stkpush`, HTTP.METHODS.POST_METHOD, form);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getPackages () {
        try {
            const storedUser = JSON.parse(localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE));
    
            if (!storedUser) {
                throw new Error(ERROR_MESSAGES.MISSING_USER_ID);
            }
            
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/allPackages`);
            if (!res.ok) {
              throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
    
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async getUserPayments (page) {
        try {
            const storedUser = JSON.parse(localStorage.getItem(SYSTEM_DEFAULTS.USER_CACHE));
    
            if (!storedUser) {
                throw new Error(ERROR_MESSAGES.MISSING_USER_ID);
            }
            
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/payments?page=${page}&limit=${SYSTEM_DEFAULTS.PAGE_SIZE}`);
            if (!res.ok) {
              throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
    
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async createSavingsPlan(form) {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/savings-plan`, HTTP.METHODS.POST_METHOD, form);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async createTransaction(form) {
        try {
            const res = await HelperFunction.getFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/transactions`, HTTP.METHODS.POST_METHOD, form);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async requestPasswordReset(form) {
        try {
            const res = await HelperFunction.getUnauthFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/reset-password-request`, HTTP.METHODS.POST_METHOD, form);
            if (!res.ok) {
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
      
            return await res.json();
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async loginRequest(form) {
        try {
            const response = await HelperFunction.getUnauthFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/login`, HTTP.METHODS.POST_METHOD, form)
            const data = response.json();
            if (!response.ok) {
                if (data.error) {
                    throw new Error(data.error);
                } else if (data.message) {
                    throw new Error(data.message);
                }
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }

            return data;
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async activateRequest(token) {
        try {
            const response = await HelperFunction.getUnauthFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/activate?token=${token}`)
            const data = response.json();
            if (!response.ok) {
                if (data.error) {
                    throw new Error(data.error);
                } else if (data.message) {
                    throw new Error(data.message);
                }
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
            return data;
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }

    static async resetPassword(form) {
        try {
            const response = await HelperFunction.getUnauthFetchObj(`${process.env.REACT_APP_WENGMACK_V1_BE_URL}/reset-password`, HTTP.METHODS.POST_METHOD, form);
            const data = await response.json();
            if (!response.ok) {
                if (data.error) {
                    throw new Error(data.error);
                } else if (data.message) {
                    throw new Error(data.message);
                }
                throw new Error(ERROR_MESSAGES.ERROR_RESPONSE);
            }
            return data;
        } catch (err) {
            throw new Error(ERROR_MESSAGES.ERROR + err);
        }
    }
}
